import { atom, useAtom } from "jotai";

const bottomNavigationDrawerOpenAtom = atom<boolean>(false);

function useBottomNavigationDrawerOpen(): [boolean, (isOpen: boolean) => void] {
  return useAtom(bottomNavigationDrawerOpenAtom);
}

export { bottomNavigationDrawerOpenAtom, useBottomNavigationDrawerOpen };
